import { render, staticRenderFns } from "./Accommodation.vue?vue&type=template&id=68cd37a7&"
import script from "./Accommodation.vue?vue&type=script&lang=ts&"
export * from "./Accommodation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports